import { createAction } from "redux-actions";

export const reset = createAction("BOARD/RESET");



// WEBPACK FOOTER //
// ./actions/board.ts